import * as React from 'react';
import classNames from 'classnames';
import './Button.scss';

export interface IButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  color?:
    | 'primary'
    | 'light'
    | 'gray'
    | 'green'
    | 'danger'
    | 'success'
    | 'dark-blue';
  size?: 'default' | 'micro' | 'small' | 'large';
  loading?: boolean;
  rounded?: boolean;
}

export function buttonClassNames(props: IButtonProps) {
  return classNames(
    'button',
    props.className,
    props.loading && 'is-loading',
    props.rounded && 'is-rounded',
    props.size ? `is-${props.size}` : 'is-small',
    props.color ? `is-${props.color}` : 'is-primary'
  );
}

export function wrapButtonChildren(children?: React.ReactNode) {
  return React.Children.map(children, child =>
    typeof child === 'string' ? <span>{child}</span> : child
  );
}

const Button = (props: IButtonProps) => {
  const {
    className,
    loading,
    rounded,
    size,
    color,
    children,
    ...buttonProps
  } = props;

  return (
    <button {...buttonProps} className={buttonClassNames(props)}>
      {wrapButtonChildren(props.children)}
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.tsx